// extracted by mini-css-extract-plugin
export default {"container":"ReturnToDashboard_container__W6NZd","backToDashboard":"ReturnToDashboard_backToDashboard__MrSae"};